import { render } from "./DetailProductRoom.vue?vue&type=template&id=5cdd8dec"
import script from "./DetailProductRoom.vue?vue&type=script&lang=js"
export * from "./DetailProductRoom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__